module.exports = "th {\r\n    min-width: 140px;\r\n}\r\n\r\nth.action-col {\r\n    min-width: 135px;\r\n}\r\n\r\ntd.trip-ticket {\r\n    text-align: center;\r\n    line-height: 40px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/trips/daily-trip-list/daily-trip-list.component.css
// module id = ./src/app/components/trips/daily-trip-list/daily-trip-list.component.css
// module chunks = main